export default {
  Illustrations: 'Illustrations',
  Cardiology: 'Cardiology',
  Neurology: 'Neurology',
  Surgery: 'Surgery',
  Urology: 'Urology',
  Gynecology: 'Gynecology',
  Obstetrics: 'Obstetrics',
  Clinician: 'Clinician',
  Pneumonology: 'Pneumonology',
  Endocrinology: 'Endocrinology',
  Orthopedics: 'Orthopedics',
  Pediatrics: 'Pediatrics',
  Hematology: 'Hematology',
  Immunology: 'Immunology',
  Parasitology: 'Parasitology',
  Nutrition: 'Nutrition',
  Odontology: 'Odontology',
  Pharmacy: 'Pharmacy',
  Nursing: 'Nursing',
  Veterinary: 'Veterinary',
  Zoology: 'Zoology',
  Botany: 'Botany',
  'Cell biology': 'Cell Biology',
  Development: 'Development',
  Entomology: 'Entomology',
  Ornithology: 'Ornithology',
  Biochemistry: 'Biochemistry',
  Chemistry: 'Chemistry',
  Genetics: 'Genetics',
  'Molecular Biology': 'Molecular Biology',
  Nanotechnology: 'Nanotechnology',
  Neuroscience: 'Neuroscience',
  Pharmacology: 'Pharmacology',
  Toxicology: 'Toxicology',
  'Earth Sciences': 'Earth Sciences',
  Education: 'Education',
  Engineering: 'Engineering',
  Geography: 'Geography',
  'Physics & Astronomy': 'Physics & Astronomy',
  Oceanography: 'Oceanography',
  'Marine biology': 'Marine Biology',
  History: 'History',
  'Others - Molecular Sciences': 'Others - Molecular Sciences',
  Others: 'Others',
};
